import "./style.css";

export function ContainerFile({ children }) {
  return <div className="container-images-delete">{children}</div>;
}
